// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"CoverVideo_videoContainer__HMiR4","video":"CoverVideo_video__6xP44","chatToggle":"CoverVideo_chatToggle__pcmVl"};